exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".left_menu {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column; }\n  .left_menu a {\n    font: 300 22px \"NunitoSans\";\n    color: #6e6e6e;\n    opacity: 0.34;\n    margin-bottom: 16px;\n    cursor: pointer; }\n  .left_menu .active-link {\n    background-color: #b9b9b9;\n    color: #1f1f1f; }\n\n.left_menu .selected {\n  opacity: 1; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/akirchhoff/Documents/Development/routerProducts/src/app/productfilter/productfilter.component.scss
// module id = ../../../../../src/app/productfilter/productfilter.component.scss
// module chunks = main